module.exports = __webpack_public_path__ + "img/Dantam Fashion 11.d044bc9d.jpg";